import React, { useContext } from 'react';
import FontListToolbar from '../../artboard/FontList';
import { FontsContext } from '../../context/fontsContext';
import { Icon } from 'antd';

import ReactDOM from 'react-dom';
const dummyStyle = {};
const absoluteStyle = { position: 'absolute' };

const FontSideBar = ({ setFontChange, editor, fontFamily,isToolBarVisible, closeFontList, isAbsolute = false, customStyle = undefined,CurrentDesign  }) => {
    const fontsContext = useContext(FontsContext);

    if(!isToolBarVisible){
      return <></>;
    }
  
    return (
      <>
        {ReactDOM.createPortal(
          <FontListToolbar
            fontList={fontsContext.fontList.fontVarients}
            onClose={() => {}}
            onFontSave={() => {
              if (editor?.current) {
                editor.current.focus();
              }
              fontsContext.handleFonts();
            }}
            editor={editor}
            setFontChange={setFontChange}
            font={fontFamily}
            isFromPortal={!isAbsolute}
            style={customStyle || (isAbsolute ? absoluteStyle : dummyStyle)}
            CurrentDesign={CurrentDesign}
          />,
          document.getElementById('sidebar-absolute-container'),
        )}
  
        {ReactDOM.createPortal(
          <div
            className="layoutbtn-container"
            onMouseDown={closeFontList}
            style={{ position: 'absolute', top: 0, left: -2, zIndex: 101 }}
          >
            <Icon type={'close'} />
          </div>,
          document.getElementById('sidebar-absolute-close'),
        )}
      </>
    );
  };


  export default FontSideBar;